import { useCallback, useRef } from 'react';

export const useRefSetter = (callback?: (any) => void) => {
  const ref = useRef(null);
  const refSetter = useCallback((node) => {
    if (node) {
      ref.current = node;
      if (callback) {
        callback(node);
      }
    }
  }, []);

  return [ref, refSetter];
};
